import axios from "axios";

const BACKEND_URL = "https://hm-services-website.onrender.com";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const submitAssessment = (data) =>
  api.post("/leads/assessment", data).then((r) => r.data);
export const submitListing = (data) =>
  api.post("/leads/listing", data).then((r) => r.data);
export const submitContact = (data) =>
  api.post("/leads/contact", data).then((r) => r.data);
